var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.351,
    height: 17.009,
    viewBox: "0 0 13.351 17.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_292",
    "data-name": "Grupo 292",
    transform: "translate(-1628.946 -83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-check-list-5023923",
    transform: "translate(1628.946 83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M158.129,19.6H146.424a.824.824,0,0,0-.823.823v12.8a.274.274,0,1,0,.549,0v-12.8a.275.275,0,0,1,.274-.274h11.705a.275.275,0,0,1,.274.274v1.1a.274.274,0,0,0,.549,0v-1.1A.824.824,0,0,0,158.129,19.6Z",
    transform: "translate(-145.601 -19.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M158.681,60.89a.274.274,0,0,0-.274.274l0,14.563a.275.275,0,0,1-.274.274H146.431a.275.275,0,0,1-.274-.274V74.6l0-2.1a.274.274,0,1,0-.549,0l0,3.226a.824.824,0,0,0,.823.823h11.705a.824.824,0,0,0,.823-.823l0-14.563a.274.274,0,0,0-.274-.274Z",
    transform: "translate(-145.608 -59.541)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M195.3,149.52a.757.757,0,0,0,.756.756h1.185a.757.757,0,0,0,.756-.756v-1.185a.757.757,0,0,0-.756-.757h-1.185a.757.757,0,0,0-.756.757Zm.549-1.185a.208.208,0,0,1,.208-.208h1.185a.208.208,0,0,1,.208.208v1.185a.208.208,0,0,1-.208.208h-1.185a.208.208,0,0,1-.208-.208Z",
    transform: "translate(-193.677 -143.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M307.3,180.756a.274.274,0,0,0,.274.274h5.9a.274.274,0,0,0,0-.549h-5.9A.274.274,0,0,0,307.3,180.756Z",
    transform: "translate(-302.019 -175.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M195.3,277.91a.757.757,0,0,0,.756.756h1.185a.757.757,0,0,0,.756-.756v-1.185a.757.757,0,0,0-.756-.757h-1.185a.757.757,0,0,0-.756.757Zm.549-1.185a.208.208,0,0,1,.208-.208h1.185a.208.208,0,0,1,.208.208v1.185a.208.208,0,0,1-.208.208h-1.185a.208.208,0,0,1-.208-.208Z",
    transform: "translate(-193.677 -267.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M313.474,308.87h-5.9a.274.274,0,1,0,0,.549h5.9a.274.274,0,0,0,0-.549Z",
    transform: "translate(-302.02 -299.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M195.3,406.3a.757.757,0,0,0,.756.757h1.185A.757.757,0,0,0,198,406.3v-1.185a.757.757,0,0,0-.756-.756h-1.185a.757.757,0,0,0-.756.756Zm.549-1.185a.208.208,0,0,1,.208-.208h1.185a.208.208,0,0,1,.208.208V406.3a.208.208,0,0,1-.208.208h-1.185a.208.208,0,0,1-.208-.208Z",
    transform: "translate(-193.677 -391.797)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21",
    "data-name": "Trazado 21",
    d: "M313.474,437.26h-5.9a.274.274,0,1,0,0,.549h5.9a.274.274,0,0,0,0-.549Z",
    transform: "translate(-302.02 -423.619)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22",
    "data-name": "Trazado 22",
    d: "M199.44,78.4h-3.864a.274.274,0,0,0,0,.549h3.864a.274.274,0,0,0,0-.549Z",
    transform: "translate(-193.678 -76.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23",
    "data-name": "Trazado 23",
    d: "M377.71,78.951a.274.274,0,1,0,0-.549h-3.864a.274.274,0,1,0,0,.549Z",
    transform: "translate(-366.126 -76.482)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.c03556af16b3b401336e8085315efdbe.svg";
export { ForwardRef as ReactComponent };